import React, { useContext, useRef } from 'react';
import styled from 'styled-components';
import Portal from '@/components/portal';
import { INSPECTOR_WRAPPER_ID } from '@/features/editor/inspector';
import { ModalLike } from '@/features/editor/widgets/ai-component/inputs/html-attr/html-attr-image-input';
import { EditorContext } from '@/features/editor/context/editor-context';
import { InlineInputCardWrapper } from '@/features/editor/widgets/ai-component/inputs/shared/shared';
import { ToolWhiteboardImageEditor } from '@/features/ai-agents/components/tool-whiteboard-image-editor';

export interface ToolWhiteboardProps {
  isWhiteboardOpen?: boolean;
  setIsWhiteboardOpen?: (open: boolean) => void;
  onUploadSketch?: (file: File) => void;
}

export function ToolWhiteboard({
  isWhiteboardOpen,
  setIsWhiteboardOpen,
  onUploadSketch,
}: ToolWhiteboardProps) {
  const imageRef = useRef<HTMLElement>(null);
  const { inspectorRef } = useContext(EditorContext);

  const onGenerated = (img: File) => {
    onUploadSketch(img);
    setIsWhiteboardOpen(false);
  };

  return (
    <Wrapper ref={imageRef}>
      {isWhiteboardOpen && (
        <Portal selector={`#${INSPECTOR_WRAPPER_ID}`}>
          <ModalLike
            style={{
              top: inspectorRef?.current.getBoundingClientRect().top,
              right: 0,
              bottom: 0,
              left: inspectorRef?.current.getBoundingClientRect().left,
            }}
          >
            <ToolWhiteboardImageEditor
              onGenerateItClicked={onGenerated}
              setIsWhiteboardOpen={setIsWhiteboardOpen}
            />
          </ModalLike>
        </Portal>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(InlineInputCardWrapper)`
  && {
    display: grid;
    grid-template-columns: auto 1fr;

    .image-preview-tile {
      max-width: 4rem;
      max-height: 4rem;
      width: auto;
      justify-self: flex-end;
    }
  }
`;
